window.onload = function() {
    const forms = document.querySelectorAll('.gform_wrapper form');

    forms.forEach(form => {
        let inputs = form.querySelectorAll('input, select, textarea')
        inputs.value = "";
        inputs.forEach(input => {
            const parentDiv = input.closest('.gfield');

            if (input.classList.contains('gfield_select')) {
                input.firstChild.setAttribute('disabled', true);
            }
            if (parentDiv) {
                input.addEventListener('focus', () => {
                    parentDiv.classList.add('focused');
                });

                input.addEventListener('blur', () => {
                    parentDiv.classList.remove('focused');

                    if (input.value.trim() !== '') {
                        parentDiv.classList.add('activated');
                    } else {
                        parentDiv.classList.remove('activated');
                    }
                });

                if (input.value.trim() !== '') {
                    parentDiv.classList.add('activated');
                } else {
                    parentDiv.classList.remove('activated');
                }
            }
        });
    });
};

